import React from "react";
import { Link } from "react-router-dom";

const Breadcrumb = ({ title, link =false, isSelectAddress = false, addressEnumChange, isChildren = false }) => {

  const handleBack = () => {
    if (isSelectAddress) {
      addressEnumChange(0);
    } else {
      if (isChildren) {
        addressEnumChange(1);
      }
    }
  }

  return (
    <div className="registration-breadcrumb">
        <div className="container">
            <div className="position-relative d-flex align-items-center justify-content-center text-center">
                <Link to={link || "/seller-register-blank" } className="position-absolute start-0 text-black text-32"><i className="ph ph-arrow-left"></i></Link>
                <div className="title text_quicksand fw-bold text-32 text-black">
                    {title}
                </div>
            </div>
        </div>
    </div>
  );
};

export default Breadcrumb;